import React, {Fragment} from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";

import {FormInputDatePicker, FormInput, FormInputToggle, SmartErrorDiv} from "root/ReactHookForm/FormComponents";

import DropdownStaticGender, {genderValues} from "root/ReactHookForm/ui/DropdownStaticGender";
import DropdownStaticSchoolYear from "root/ReactHookForm/ui/DropdownStaticSchoolYear";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

const HookSubFormChildDetails = ({control, register, watch, formMode, formErrors, sectionName, readOnly, search }) =>
{
    const validateGender = (val) =>
    {
        if (val === null)
        {
            return "Please Select a gender.";
        }
    }

    const validateSchoolYear = (val) =>
    {
        if (val === null)
        {
            return "Please Select a year.";
        }
    }

    const [ selectedGender ] = useWatchDropdown( {control, name: sectionName + '.' + 'gender' }) ;

    const c1Width = selectedGender === genderValues.OTHER ? 3 : 6 ;
    const showDetails = selectedGender === genderValues.OTHER ;

    return (
        <Fragment>
            <BootstrapRow key='dr1'>
                <BootstrapCol width={6}>
                    <FormInput readOnly={readOnly} label='First Name' sectionName={sectionName} name={'firstname'} register={register} required={true} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={3}>
                    <FormInput readOnly={readOnly} label='Middle Names' sectionName={sectionName} name={'middlename'} register={register} required={false} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={3}>
                    <FormInput readOnly={readOnly} label='Last Name' sectionName={sectionName} name={'surname'} register={register} required={true} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>

            { search === false && <BootstrapRow key='dr2'>
                <BootstrapCol width={3}>
                    <FormInput readOnly={true} label='ESW Name' sectionName={sectionName} name={'esw_name'} register={register} required={false} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={3}>
                    <FormInput readOnly={true} label='ESW Email' sectionName={sectionName} name={'esw_email'} register={register} required={false} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={3}>
                    <FormInputDatePicker readOnly={readOnly} label='Date pupil first became CfC' sectionName={sectionName}
                                         name={'date_became_lac'}
                                         control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={3} key='dp1'>
                    <FormInputDatePicker readOnly={readOnly} label='Date pupil last became CfC' sectionName={sectionName}
                                         name={'date_last_became_lac'}
                                         control={control} required={false} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow> }

            { search === false && <BootstrapRow key='dr3'>
                <BootstrapCol width={6} key='dp2'>
                    <FormInputDatePicker readOnly={readOnly} label='Pupil Date of Birth' sectionName={sectionName}
                                         name={'date_of_birth'}
                                         control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={3}>
                    <label className='col-form-label'>School Year</label>
                    <DropdownStaticSchoolYear key='dry' name={sectionName + '.year_id'} control={control} register={register} rules={{validate: validateSchoolYear}}
                                         placeHolder='Select a School Year' readOnly={readOnly}/>
                    {formErrors[sectionName]?.year_id?.type === 'validate' && <ErrorDiv>Please select a School Year</ErrorDiv>}
                </BootstrapCol>
                <BootstrapCol width={3}>
                    <FormInputToggle readOnly={readOnly} control={control} label='Pupil Offset' sectionName={sectionName} name={'is_held_back'} register={register}/>
                    <SmartErrorDiv sectionName={sectionName} name={'is_held_back'}  formErrors={formErrors} />
                </BootstrapCol>
            </BootstrapRow> }

            { search === false && <BootstrapRow key='dr4'>
                <BootstrapCol width={3}>
                    <FormInput readOnly={readOnly} label='UPN' sectionName={sectionName} name={'child_upn'} register={register} required={false} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={3}>
                    <FormInput readOnly={readOnly} label='ICS Reference' sectionName={sectionName} name={'ics_ref'} register={register} required={false} maxLength={100} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={c1Width}>
                    <label className='col-form-label'>Gender</label>
                    <DropdownStaticGender name={sectionName + '.gender'} control={control} register={register} rules={{validate: validateGender}}
                                         placeHolder='Select a gender' readOnly={readOnly}/>
                    {formErrors[sectionName]?.gender?.type === 'validate' && <ErrorDiv>Please select a Gender</ErrorDiv>}
                </BootstrapCol>
                { showDetails === true && <BootstrapCol width={3}>
                    <FormInput readOnly={readOnly} label='Detail' sectionName={sectionName} name={'gender_detail'} register={register} required={showDetails} maxLength={200} formErrors={formErrors}/>
                    {formErrors[sectionName]?.gender_detail?.type === 'validate' && <ErrorDiv>Please enter details</ErrorDiv>}
                </BootstrapCol> }
            </BootstrapRow> }

           </Fragment>
    )
}


export default HookSubFormChildDetails;
